export default {
  methods: {
    formatPrice: function (price) {
      if (isNaN(price)) { return 0 }
      price = price / 100;
      return (price % 1 === 0 ? price : price.toFixed(2));
    },
  }
}